import Swiper, {Pagination} from 'swiper';
import { throttle } from '../decorators';
import Viewport from '../common/viewport';
import { logError } from '../utils/logError';

export class ProductImageSlider {
    static _observedUninitializedSliders = [];
    static _viewport = new Viewport(window);

    constructor() {
        Swiper.use([Pagination]);

        this.scanUninitializedSliders = this.scanUninitializedSliders.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.throttledHandleScroll = throttle(this.handleScroll, 100);
        this.createSlider = this.createSlider.bind(this);

        this.scanUninitializedSliders();
        this.handleScroll();

        document.addEventListener('catalogupdate', () => {
            this.scanUninitializedSliders();
            this.handleScroll();
        });
    }

    scanUninitializedSliders() {
        document.removeEventListener('scroll', this.throttledHandleScroll);
        document.removeEventListener('resize', this.throttledHandleScroll);

        const selector = '.js-product-image-slider:not(.swiper-container-initialized):not(.js-product-image-slider-observed)',
            uninitializedSliders = [...document.querySelectorAll(selector)];

        for (const slider of uninitializedSliders) {
            slider.classList.add('js-product-image-slider-observed');
            ProductImageSlider._observedUninitializedSliders.push(slider);
        }

        if (ProductImageSlider._observedUninitializedSliders.length > 0) {
            document.addEventListener('scroll', this.throttledHandleScroll);
            document.addEventListener('resize', this.throttledHandleScroll);
        }
    }

    handleScroll() {
        let length = ProductImageSlider._observedUninitializedSliders.length;
        for (let i = 0; i < length; i++) {
            const slider = ProductImageSlider._observedUninitializedSliders[i];
            if (ProductImageSlider._viewport.isVisible(slider)) {
                ProductImageSlider._observedUninitializedSliders.splice(i--, 1);
                this.createSlider(slider);
            }
        }

        if (ProductImageSlider._observedUninitializedSliders.length === 0) {
            document.removeEventListener('scroll', this.throttledHandleScroll);
            document.removeEventListener('resize', this.throttledHandleScroll);
        }
    }

    createSlider(slider) {
        const images = slider.querySelectorAll('img');
        if (images.length < 2) {
            return;
        }

        if (images[0].classList.contains('lazyloading')) {
            images[0].classList.remove('lazyloading');
        }

        const swiperWrapper = slider.querySelector('.swiper-wrapper');
        if (!swiperWrapper)
            return;

        new Swiper(slider, {
            pagination: {
                el: '.swiper-pagination'
            },
            on: {
                afterInit: function() {
                    // Moving pagination to overcome overflow: hidden css property
                    const pagination = slider.querySelector('.swiper-pagination');
                    pagination?.parentElement?.parentElement.append(pagination);
                }
            }
        });
    }
}
